module.exports = __webpack_public_path__ + "img/goodsB2.7c650016.png";